import { render, staticRenderFns } from "./kolAuditDetail.vue?vue&type=template&id=50f5274c&scoped=true&"
import script from "./kolAuditDetail.vue?vue&type=script&lang=js&"
export * from "./kolAuditDetail.vue?vue&type=script&lang=js&"
import style0 from "./kolAuditDetail.vue?vue&type=style&index=0&id=50f5274c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5274c",
  null
  
)

export default component.exports